import { useEffect } from "react";

const SITE_BASE_URL = "https://venturafreshlaundry.com";
const DEFAULT_IMAGE = `${SITE_BASE_URL}/logo-ventura.png`;

function setMetaByName(name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

const DYNAMIC_JSON_LD_ID = "dynamic-page-jsonld";

function setJsonLd(data) {
  let tag = document.getElementById(DYNAMIC_JSON_LD_ID);
  if (!data) {
    if (tag) tag.remove();
    return;
  }
  if (!tag) {
    tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.id = DYNAMIC_JSON_LD_ID;
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
}

function setCanonical(path) {
  const href = path ? `${SITE_BASE_URL}${path}` : SITE_BASE_URL;
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
  return href;
}

/**
 * Updates document.title and the key SEO/OG/Twitter meta tags for the
 * current route. Each public page calls this with its own title/description
 * so every URL gets distinct, keyword-relevant metadata instead of the one
 * generic tag set baked into index.html — client-side rendered pages still
 * get this applied before Googlebot's render pass, and it keeps the browser
 * tab title and social-share previews correct for in-app navigation too.
 */
export function useSEO({ title, description, path, image, jsonLd }) {
  useEffect(() => {
    if (title) document.title = title;
    setMetaByName("description", description);
    const canonicalUrl = setCanonical(path);
    setMetaByProperty("og:title", title);
    setMetaByProperty("og:description", description);
    setMetaByProperty("og:url", canonicalUrl);
    setMetaByProperty("og:image", image || DEFAULT_IMAGE);
    setMetaByName("twitter:title", title);
    setMetaByName("twitter:description", description);
    setMetaByName("twitter:image", image || DEFAULT_IMAGE);
    setJsonLd(jsonLd);
    return () => setJsonLd(null);
  }, [title, description, path, image, jsonLd]);
}
